import React from 'react'
import { useState } from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'

import { formatVideoLength } from 'utils/formatVideoLength'

import LeidModal from '../Modal/LeidModal'

import { Player, PlayerWrapper, StyledLoader } from './styles'

type Props = {
  isOpen: boolean
  onClose: () => void
  videoUrl: string
  videoTitle: string
  videoLength: string | null
}

export const VideoModal: React.FC<Props> = ({ isOpen, onClose, videoUrl, videoTitle, videoLength }) => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <LeidModal header={videoTitle} isOpen={isOpen} onClose={onClose} size={{ base: 'cover', md: 'xl' }}>
      <Flex
        width="54px"
        height="54px"
        backgroundColor="green.a200"
        borderRadius="12px"
        position="absolute"
        right={{ base: 0, md: '-74px' }}
        top={{ base: '-74px', md: 0 }}
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        onClick={onClose}
      >
        <img src="/icons/close-light.svg" alt="Close" />
      </Flex>

      <Flex align="flex-start" height="100%">
        <Box flexGrow={1}>
          <PlayerWrapper>
            {isLoading && <StyledLoader />}
            <Player
              onReady={() => {
                setIsLoading(true)
              }}
              url={videoUrl}
              width="100%"
              height="100%"
            />
          </PlayerWrapper>

          {videoLength && (
            <Text color="green.a200" fontSize="sm" fontWeight="700">
              {formatVideoLength(videoLength)}
            </Text>
          )}
        </Box>
      </Flex>
    </LeidModal>
  )
}
